import { render, staticRenderFns } from "./Summary.template.vue?vue&type=template&id=0a99121c&scoped=true&"
var script = {}
import style0 from "./Summary.template.vue?vue&type=style&index=0&id=0a99121c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99121c",
  null
  
)

export default component.exports